export const EXAMPLE_TEXT = `I was an American Christian minister and activist who became the most visible
spokesperson and leader in the Civil Rights Movement from 1955 until his assassination
in 1968. King is best known for advancing civil rights through nonviolence and civil
disobedience, inspired by his Christian beliefs and the nonviolent activism of Mahatma
Gandhi.`;
